export default __webpack_public_path__ + "static/media/JoshEvans.c5c48440.jpg";